import { Fragment , useState , useCallback, useEffect, useContext } from "react";
import { connect } from 'react-redux';
import useForm from '../../hooks/useForm';
import { addressForm, paymentForm } from '../../utils/formConfig';
import ContactData from './ContactData/ContactData';
import OrderSummary from './OrderSummary/OrderSummary';
import AuthContext from "../../store/auth-context";
import { submitOrder , deleteCart } from "../../store/actions/index";
import { Redirect } from "react-router";

import Grid from '@mui/material/Grid';


const Checkout = props => {

    const authCtx = useContext(AuthContext);

    const { cartItems, submitOrderHandler , hasSubmittedOrder, clearCartHandler } = props;
    
    const [ subTotalPrice , setSubTotalPrice ] = useState(0);
    const [ ShippingPrice , setShippingPrice ] = useState(10);

    const { renderFormInputs: addressData, isFormValid: isAddressValid , form: addressFormData} = useForm(addressForm);
    const { renderFormInputs: paymentData, isFormValid : isPaymentValid , form: paymentFormData } = useForm(paymentForm);
    
    const formIsValid = isAddressValid() && isPaymentValid();

    useEffect(() => {
        const updatePrice = cartItems.reduce((sum, entry) => {
            return sum + ( (entry.priceCents * entry.quantity ) / 100 )
        }, 0)
        if (updatePrice > 100) {
            setShippingPrice(0);
        } else {
            setShippingPrice(10);
        }
        setSubTotalPrice(updatePrice);

    }, [ cartItems ] )

    useEffect(() => {
        if (hasSubmittedOrder) {
            clearCartHandler()
        }
    }, [ hasSubmittedOrder, clearCartHandler ]);

    const submitFormHandler = useCallback( ( e ) => {
        e.preventDefault();
        const userData = {
            name: paymentFormData.name.value,
            address: addressFormData.address.value,
            city: addressFormData.city.value,
            state: addressFormData.state.value,
            zipCode: addressFormData.zipCode.value,
            payment: paymentFormData.payment.value,
            orderContent: cartItems,
            subTotal: subTotalPrice,
            shipping: ShippingPrice,
        }
        console.log(userData);
        submitOrderHandler( userData , authCtx.token );
    } , [ addressFormData, paymentFormData, cartItems, subTotalPrice, ShippingPrice, authCtx, submitOrderHandler ] )

    const redirect = <Redirect to='/' />

    return (
        <Fragment>
            {hasSubmittedOrder && redirect}
            <Grid container >
                    <Grid item xs={12} md={6}>
                        <ContactData addressData={addressData} isAddressValid={isAddressValid} paymentData={paymentData} isPaymentValid={isPaymentValid} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <OrderSummary valid={formIsValid} subTotal={subTotalPrice} shipping={ShippingPrice} payment={paymentFormData.payment.value} onConfirm={submitFormHandler} />
                    </Grid>
            </Grid>
        </Fragment>
    )
}

const mapDispatchToProps = dispatch =>{
    return {
        submitOrderHandler : ( userData , token ) => dispatch( submitOrder( userData , token) ),
        clearCartHandler: ( ) => dispatch( deleteCart( ) ),
    }
}
const mapStateToProps = state =>{
    return {
        cartItems: state.cart.cartItems,
        hasSubmittedOrder: state.orders.submitingOrderSucess,
    }
}


export default connect( mapStateToProps , mapDispatchToProps )(Checkout);